import React, { useState, useEffect } from "react";
import style from "./VrtSession.module.sass";

const ToggleButtons = ({ title, initialStatus = true, onToggle, name }) => {
  const [status, setStatus] = useState(initialStatus); // Stato corretto

  // Sincronizza lo stato quando cambia initialStatus
  useEffect(() => {
    console.log("Initial status changed:", initialStatus);
    setStatus(initialStatus);
  }, [initialStatus]);

  const handleToggle = (e, newStatus) => {
    e.preventDefault();
    setStatus(newStatus); // Aggiorna lo stato locale
    if (onToggle) {
      onToggle(name, newStatus); // Invia l'aggiornamento al parent
    }
  };

  return (
    <div className={style.formGroup}>
      <label>{title}</label>
      <div className={style.toggleGroup}>
        <button
          name={name}
          value={true}
          className={`${style.toggleButton} ${status ? style.active : ""}`}
          onClick={(e) => handleToggle(e, true)}
        >
          On
        </button>
        <button
          name={name}
          value={false}
          className={`${style.toggleButton} ${!status ? style.active : ""}`}
          onClick={(e) => handleToggle(e, false)}
        >
          Off
        </button>
      </div>
    </div>
  );
};

export default ToggleButtons;
